import React from 'react';

const CatalogoPisoDePvcRigido = () => {
  return (
    <section>
      <div className="container">
        <div className="title-style2 text-center mb-2-2 wow fadeIn" data-wow-delay="200ms">
          <h2 className="h1">Modelos Piso de PVC Rígido</h2>
          <p>es una solución moderna y funcional para diversos espacios. Su diseño modular permite una instalación rápida y sencilla, sin necesidad de adhesivos ni herramientas especializadas. Este piso combina resistencia, durabilidad y facilidad de mantenimiento, convirtiéndose en una excelente opción para áreas de alto tránsito.</p>
        </div>
        <div className="row gx-5 mt-n1-9 text-center">
          <div className="col-sm-6 col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="300ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/productos/piso-de-pvc-rigido/catalogo-piso-de-pvc-rigido-amarillo.jpg" 
                  alt="piso vinilico gris" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Piso Amarillo</h5>
                  <span></span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="450ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/productos/piso-de-pvc-rigido/catalogo-piso-de-pvc-rigido-azul.jpg" 
                  alt="piso vinilico madera" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Piso Azul</h5>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Si necesitas activar el tercer modelo, puedes descomentar este bloque */} 
          {/* 
          <div className="col-sm-6 col-lg-4 mt-1-9 wow fadeInUp" data-wow-delay="600ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/piso-vinilico-modelo-otro.jpg" 
                  alt="piso vinilico otro modelo" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Otro modelo</h5>
                  <span>Modelos: otro</span>
                </div>
              </div>
            </div>
          </div>
          */}
        </div>
      </div>
      <div className="circle-md right-10 top-35 border-secondary-color d-none d-lg-block"></div>
    </section>
  );
};

export default CatalogoPisoDePvcRigido;